export const localeNL = {
  lang: 'nl',
  data: {
    NAV: {
      APPLICATIONS: 'Applicatie',
      DASHBOARD: 'Dashboard',
      ADMINISTRATIONS: 'Administraties',
      USERS: 'Gebruikers',
      PROSPECT: 'Prospect',
      SYSTEM: 'Systeem',
      ORIGIN: 'Origins',
      DOCUMENTS: 'Documenten',
      PROSPECTS: 'Prospects',
      PROSPECT_PENDING: 'In afwachting',
      PROSPECT_ACCEPTED: 'Geaccepteerd',
      PROSPECT_REJECTED: 'Afgekeurd',
      PROSPECT_PROCESSED: 'Verwerkt',
      ADD_PROSPECT: 'Nieuwe prospect',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/navigation/i18n/nl.ts